<template>
    <v-row>
        <v-col cols="12" lg="6" md="9" >
            <v-card class="mt-5">
                <v-card-title class="grey lighten-4 p-2">
                    <h5 class="m-0 font-weight-bold text-break" v-if="(!prepay && reservationType==='advance' && only_save_card_at_advanced) || (prepay && only_save_card_at_prepay)">
                        Please enter your credit card to save this reservation, you will not be charged at this time
                    </h5>
                    <h4 class="m-0" v-else>
                        Reservation Total: <span class="blue--text text--accent-4">${{ amount }}</span>
                        <span class="error--text  text-break" v-if="charge_50_percent || charge_25_percent || charge_10_percent || charge_10_per_person || charge_20_per_person || charge_30_per_person">
                           ( {{ deposite_text }} )
                         </span>
                    </h4>
                </v-card-title>
                <div class="p-2">
                    <h4 class="m-0" v-if="(!prepay && reservationType==='advance' && only_save_card_at_advanced) || (prepay && only_save_card_at_prepay)">
                        <span class=" error--text"> Reservation Total:</span> <span class="blue--text text--accent-4">${{ amount }}</span> 
                         <span class="error--text  text-break" v-if="charge_50_percent || charge_25_percent || charge_10_percent || charge_10_per_person || charge_20_per_person || charge_30_per_person">
                           ( {{ deposite_text }} )
                         </span>
                    </h4>
                    <span class="mt-5 error--text  text-break" v-if="advance_reservation_payment_checkout && (!charge_50_percent && !charge_25_percent && !charge_10_percent && !charge_10_per_person && !charge_20_per_person && !charge_30_per_person) && !only_save_card_at_advanced">
                        Please enter your credit card information to complete the reservation
                    </span>
<!--                    <span class="mt-5 error&#45;&#45;text  text-break" v-if="securitydeposit">-->
<!--                        Please Enter Credit Card Information that is used as a security Deposit.-->
<!--                    </span>-->
                    <with-validation field="cc" v-slot="{bind,on}">
                        <v-text-field
                            class="mt-1"
                            outlined
                            clearable
                            label="Credit Card"
                            type="text"
                            v-mask="'NNNN NNNN NNNN NNNN'"
                            v-bind="bind"
                            v-on="on"
                            autocomplete="cc-number"
                        >

                            <template v-slot:append>
                                <img
                                    class="d-none d-md-block"
                                    width="130"
                                    height="24"
                                    src="/img/creditcards.png"
                                    alt=""
                                >
                            </template>
                        </v-text-field>
                    </with-validation>
                    <v-row class="mt-2">
                        <v-col cols="4">
                            <with-validation field="expiration_month" v-slot="{bind,on}">

                                <v-select
                                    label="MM"
                                    v-bind="bind"
                                    v-on="on"
                                    menu-props="auto"
                                    ref="exp_month"
                                    class="smaller-list"
                                    @update:search-input="testMonthInput"
                                    autocomplete="cc-exp-month"
                                    :items="available_months">
                                </v-select>

                            </with-validation>
                        </v-col>
                        <v-col cols="4">
                            <with-validation field="expiration_year" v-slot="{bind,on}">
                                <v-select
                                    label="YY"
                                    v-bind="bind"
                                    v-on="on"
                                    menu-props="auto"
                                    ref="exp_year"
                                    @update:search-input="testYearInput"
                                    class="smaller-list"
                                    autocomplete="cc-exp-year"
                                    :items="available_years">
                                </v-select>
                            </with-validation>
                        </v-col>
                        <v-col class="d-flex flex-row">
                            <div style="padding-bottom: 25px;flex-basis: 0; flex-grow: 1;"
                                 class="desktop-block d-flex justify-content-center"
                            >
                                <v-divider vertical class="mx-4"></v-divider>
                            </div>

                            <with-validation field="cvv" v-slot="{bind,on}">
                                <v-text-field
                                    dense
                                    style="flex-basis: 100px;flex-grow: 0"
                                    outlined
                                    label="cvv"
                                    type="text"
                                    v-mask="'####'"
                                    v-bind="bind"
                                    v-on="on"
                                ></v-text-field>
                            </with-validation>
                        </v-col>
                    </v-row>
                </div>
            </v-card>

        </v-col>
        <v-col cols="12">
            <with-validation field="agreement" v-slot="{bind,on}">
                <v-checkbox v-bind="bind"
                            v-on="on">

                    <template v-slot:label>
                        I have read and agree to the <a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_terms'})">Terms &
                        Conditions</a>,
                        <span v-if="show_sms_consent">
                            <a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_sms_consent'})">{{ sms_constent_title }}</a>,
                        </span>
                        <a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_privacy_policy'})">Privacy
                        Policy</a>
                        and
                        <a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_cancelation_policy'})">Cancelation
                        Policy</a>
                    </template>
                </v-checkbox>
            </with-validation>
        </v-col>
    </v-row>
</template>

<script>
import WithValidation           from "../../../../components/inputs/WithValidation";
import UiManagerMixin           from "../../../../mixins/UiManagerMixin";
import ValidatableComponent     from "../../../../mixins/ValidatableComponent";
import reservation_form__fields from "../../../../validation/fields/reservation_form__fields";
import cc_form__rules           from "../../../../validation/scenarios/cc_form__rules";
import reservation_form__rules  from "../../../../validation/scenarios/reservation_form__rules";
import step_2                   from "../../validation/step_2";
import {mapActions, mapGetters} from "vuex";

export default {
    name      : "PaymentWidget",
    components: {WithValidation},
    props     : ['amount','validationId', 'reservationType', 'swipeMode', 'prepay'],
    data      : () => ({
        deposite_text: "",
    }),
    mixins    : [ValidatableComponent, UiManagerMixin],
    computed  : {
        available_months() {
            return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
        },
        available_years() {
            const currentYear = (new Date()).getFullYear();
            const availableYears = [currentYear.toString()];
            for (let i = currentYear; i < currentYear + 15; i++) {
                availableYears.push(i.toString());
            }
            return availableYears;
        },
        payment() {
            return this.$store.state.model.payment;
        },
        only_save_card_at_advanced() {
            return parseInt(this.$store.state.resources.config.only_save_card_at_advanced);
        },
        advance_reservation_payment_checkout(){
            return parseInt(this.$store.state.resources.config.advance_reservation_payment_checkout);
        },
        charge_50_percent(){
            return parseInt(this.$store.state.resources.config.charge_50_percent);
        },
        charge_25_percent(){
            return parseInt(this.$store.state.resources.config.charge_25_percent);
        },
        charge_10_percent(){
            return parseInt(this.$store.state.resources.config.charge_10_percent);
        },
        charge_10_per_person(){
            return parseInt(this.$store.state.resources.config.charge_10_per_person);
        },
        charge_20_per_person(){
            return parseInt(this.$store.state.resources.config.charge_20_per_person);
        },
        charge_30_per_person(){
            return parseInt(this.$store.state.resources.config.charge_30_per_person);
        },
        is_crested_text() {
            return parseInt(this.$store.state.resources.config.is_crested_text);
        },
        securitydeposit(){
            return parseInt(this.$store.state.resources.config.securitydeposit);
        },
        gatewayMode(){
            return this.$store.state.resources.config.gateway_mode;
        },
        gateway(){
            return this.$store.state.resources.config.gateway;
        },
        charge(){
            return this.$store.state.resources.config;
        },
        prepay_payment(){
            return parseInt(this.$store.state.resources.config.prepay_payment);
        },
        show_sms_consent() {
            return parseInt(this.$store.state.resources.config.sms_app);
        },
        sms_constent_title() {
            return this.$store.state.resources?.policy_and_terms?.sms_consent?.title || 'SMS Consent'
        },
        only_save_card_at_prepay(){
            return parseInt(this.$store.state.resources.config.only_save_card_at_prepay);
        }

    },
    watch:{
        validationId(val){
            if(val) {
                this.withValidation({validationId: val})
            }
        }
    },
    mounted() {
        if(this.validationId === false) {
            const self = this;
            this.withValidation(
                {
                    getModel() {
                        return self.$store.state.model.payment;
                    },
                    rules : this.$store.state.resources.config.gateway !== "stripe" ? cc_form__rules: '',
                    fields: {}
                }
            )
        };
        if(this.charge_50_percent == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 50% deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 50% deposit to save your reservations";
            }
        }else if(this.charge_25_percent == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 25% deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 25% deposit to save your reservations";
            }
        }else if(this.charge_10_percent == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 10% deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 10% deposit to save your reservations";
            }
        }else if(this.charge_10_per_person == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 10$ deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 10$ deposit to save your reservations";
            }
        }else if(this.charge_20_per_person == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 20$ deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 20$ deposit to save your reservations";
            }
        }else if(this.charge_30_per_person == "1" ){
            if(this.is_crested_text == "1"){
                this.deposite_text = "You are paying a 30$ deposit at this time, the remaining balance will be collected at the shop";
            }else{
                this.deposite_text = "We are taking a 30$ deposit to save your reservations";
            }
        }
        if(this.gateway == "authorize" && this.gatewayMode == "demo"){
        
            let next_year = parseInt(new Date().getFullYear()) + 5;
            next_year = next_year.toString();
            this.$store.commit('set_model_value', {
                path : 'model.payment.expiration_year',
                value: next_year
            });
            this.$store.commit('set_model_value', {
                path : 'model.payment.expiration_month',
                value: '05'
            });
            this.$store.commit('set_model_value', {
                path : 'model.payment.cvv',
                value: '123'
            });
            this.$store.commit('set_model_value', {
                path : 'model.payment.cc',
                value: '4111 1111 1111 1111'
            });
        }
    },
    methods: {
        testMonthInput(month) {
            if (month) {
                this.$store.commit('set_model_value', {
                    path : 'model.payment.expiration_month',
                    value: month
                })
                this.$refs.exp_month.blur();
            }
        },

        testYearInput(year) {
            if (year) {
                this.$store.commit('set_model_value', {
                    path : 'model.payment.expiration_year',
                    value: year
                })
                this.$refs.exp_year.blur();
            }
        }
    }
}
</script>

<style>
.v-input--selection-controls .v-input__slot > .v-label{
    display: inline-block !important;
}
</style>

<style scoped>
@media (max-width: 575.98px) {
    .desktop-block{
        display: none !important;
    }
    .mobile-block{
        display: block;
    }
}

@media (min-width: 576px){
    .mobile-block{
        display: none;
    }
    .desktop-block{
        display: flex !important;
    }
}
</style>
